/*
 * ZAKU rich-text statement ([data-zk-richtext]): the statement starts white and each character
 * turns yellow as it scrolls through the viewport. Loaded by home-rich-text and by the PDP
 * editorial in main-product (a section's {% javascript %} only runs on pages that render it).
 */
(function () {
  if (window.zkRichtextLoaded) return;
  window.zkRichtextLoaded = true;

  function initStatement(root) {
    if (root.hasAttribute('data-zk-richtext-ready')) return;
    root.setAttribute('data-zk-richtext-ready', '');
    var el = root.querySelector('[data-zk-statement]');
    if (!el) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Wrap each character (words kept unbreakable so wrapping stays natural)
    var spans = el.querySelectorAll('.zk-richtext__yellow, .zk-richtext__white');
    var chars = [];
    spans.forEach(function (span, si) {
      var text = span.textContent;
      span.textContent = '';
      var words = text.split(/(\s+)/);
      words.forEach(function (w) {
        if (!w) return;
        if (/^\s+$/.test(w)) { span.appendChild(document.createTextNode(' ')); return; }
        var word = document.createElement('span');
        word.className = 'zk-richtext__word';
        word.style.whiteSpace = 'nowrap';
        for (var i = 0; i < w.length; i++) {
          var c = document.createElement('span');
          c.className = 'zk-richtext__char';
          c.textContent = w[i];
          word.appendChild(c);
          chars.push(c);
        }
        span.appendChild(word);
      });
      if (si < spans.length - 1) span.appendChild(document.createTextNode(' '));
    });
    root.classList.add('zk-richtext--js');
    if (!chars.length) return;

    if (reduce) { chars.forEach(function (c) { c.classList.add('is-lit'); }); return; }

    var lit = -1, ticking = false;
    function update() {
      ticking = false;
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight;
      // 0 when the text top enters at 85% of the viewport, 1 when its bottom passes 25%
      var start = vh * 0.85, end = vh * 0.25;
      var p = (start - r.top) / (r.height + (start - end));
      p = Math.max(0, Math.min(1, p));
      var n = Math.round(p * chars.length);
      if (n === lit) return;
      for (var i = 0; i < chars.length; i++) chars[i].classList.toggle('is-lit', i < n);
      lit = n;
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  // The outline mark lags the text: it travels less than the section does while
  // the section crosses the viewport. The home/collection mark stays fixed on
  // small screens so it keeps lining up with the carousel mark above it.
  function initParallax(root, markSelector, lockOnNarrow) {
    if (root.hasAttribute('data-zk-wm-parallax')) return;
    var mark = root.querySelector(markSelector);
    if (!mark) return;
    root.setAttribute('data-zk-wm-parallax', '');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var narrow = window.matchMedia('(max-width: 749px)');
    var ticking = false;
    function update() {
      ticking = false;
      if (lockOnNarrow && narrow.matches) { mark.style.transform = ''; return; }
      var r = root.getBoundingClientRect();
      var vh = window.innerHeight;
      var p = (vh - r.top) / (vh + r.height);
      p = Math.max(0, Math.min(1, p));
      var range = Math.min(160, Math.max(48, r.height * 0.28));
      var y = (0.5 - p) * range;
      mark.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    if (narrow.addEventListener) narrow.addEventListener('change', onScroll);
    update();
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-zk-richtext]').forEach(function (root) {
      initStatement(root);
      initParallax(root, '.zk-richtext__watermark', true);
    });
    scope.querySelectorAll('.zk-outro').forEach(function (root) {
      initParallax(root, '.zk-outro__watermark', false);
    });
  }

  function boot() {
    initAll(document);

    // The PDP variant switcher re-renders the editorial (main-product zkInitSwapped)
    var prevInit = window.zkInitSwapped;
    window.zkInitSwapped = function (el) {
      if (prevInit) prevInit(el);
      initAll(el);
    };

    // "OUR PHILOSOPHY ↓" without a link: smooth-scroll to the following section
    document.querySelectorAll('[data-zk-richtext] [data-zk-next-section]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var section = btn.closest('.shopify-section');
        var next = section && section.nextElementSibling;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (next) next.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
